/* eslint-disable no-undef */
import VueRouter from 'vue-router'
import Vue from 'vue'
import VueGtm from 'vue-gtm'
import VueMeta from 'vue-meta'
import jwtDecode from 'jwt-decode'
import Login from './pages/Login.vue'
import MasterLayout from './layouts/Master.vue'
import Users from './pages/users/Users.vue'
import Notifications from './pages/Notifications.vue'
import Profile from './pages/Profile.vue'
import EditUser from './pages/users/EditUser.vue'
import InviteUser from './pages/invites/InviteUser.vue'
import AcceptInvite from './pages/invites/Accept.vue'
import NotFound from './pages/errors/404.vue'
import ForgotPassword from './pages/auth/ForgotPassword.vue'
import UpdatePassword from './pages/auth/UpdatePassword.vue'
import ReportReview from './pages/reviews/ReportReview.vue'
// import ReviewDetail from './pages/reviews/BusinessReviewDetail.vue'
import PublicLayout from './layouts/Public.vue'
import BusinessProfile from './pages/business/Profile.vue'
import HomePage from './pages/Home.vue'
import HomeNew from './pages/home/HomeNew.vue'
import Features from './pages/Features.vue'
import BillingHistory from './pages/billing/History.vue'
import BillingDetails from './pages/billing/Details.vue'
import BillingIndex from './pages/billing/new/BillingIndex.vue'
import BillingEditPlan from './pages/billing/new/BillingEditPlan.vue'
import EFTManualMatching from './pages/billing/EFTManualMatching.vue'
import Invoices from './pages/billing/Invoices.vue'
import RenewPackage from './pages/billing/RenewPackage.vue'
import RenewPackagePaymentDetails from './pages/billing/RenewPackagePaymentDetails.vue'
import PurchaseAdditionalReviews from './pages/billing/PurchaseAdditionalReviews.vue'
import PurchaseAdditionalReviewsPaymentDetails from './pages/billing/PurchaseAdditionalReviewsPaymentDetails.vue'
import ReviewDashboard from './pages/dashboard/ReviewDashboard.vue'
import BusinessOnboardVerification from './pages/admin/BusinessOnboardVerification'
import Businesses from './pages/admin/BusinessListing'
import BusinessDetails from './pages/admin/BusinessDetails'
import BusinessAliases from './pages/admin/BusinessAliases'
import BusinessBilling from './pages/admin/BusinessBilling'
import BusinessInvoices from './pages/admin/BusinessInvoices'
import BusinessReviews from './pages/admin/BusinessReviews'
import BusinessReviewDetails from './pages/admin/BusinessReviewDetails'
import BusinessUsers from './pages/admin/BusinessUsers'
import BusinessLayout from './layouts/BusinessLayout.vue'
import NPSReviewFromEmailRedirect from './pages/nps/NPSReviewRedirectFromEmail.vue'
import NPSThankYou from './pages/nps/NPSThankYou.vue'
import ReviewInvitesLayout from './pages/collect-reviews/ReviewInvitesLayout.vue'
import ReviewInviteSends from './pages/collect-reviews/ReviewInviteSends.vue'
import ReviewInviteTemplate from './pages/collect-reviews/ReviewInviteTemplate.vue'
import ReviewInviteSMSSetup from './pages/collect-reviews/ReviewInviteSMSSetup.vue'
import ReviewInviteGoogleReviews from './pages/collect-reviews/ReviewInviteGoogleReviews.vue'
import ReviewsShare from './pages/collect-reviews/ReviewsShare.vue'
import CollectReviewsMobile from './pages/collect-reviews/CollectReviewsMobile'
import Badges from './pages/onsite-widgets/Badges.vue'
import WidgetDetails from './pages/onsite-widgets/WidgetDetails.vue'
import WidgetLayout from './layouts/WidgetLayout.vue'
import BusinessStatsWidget from './widgets/BusinessStatsWidget.vue'
import TopReviewsVertical from './widgets/TopReviewsVertical.vue'
import TopReviewsCarousel from './widgets/TopReviewsCarousel.vue'
import TrustIndexFrameWidget from './widgets/TrustIndexFrameWidget.vue'
import StarRatingWidgetFrame from './widgets/StarRatingWidgetFrame.vue'
import ReportedReviewsListing from './pages/reported-reviews/ReportedReviewsListing.vue'
import ReportedReviewDetails from './pages/reported-reviews/ReportedReviewDetails.vue'
import SweepReviewsListing from './pages/sweep/SweepReviewsListing.vue'
import UsersLayout from './pages/users/UsersLayout.vue'
import ReviewersListing from './pages/users/ReviewersListing.vue'
import BusinessUsersListing from './pages/users/BusinessUsersListing.vue'
import ReviewerDetails from './pages/users/ReviewerDetails.vue'
import BizUserDetails from './pages/users/BizUserDetails.vue'
import ReviewsListing from './pages/reviews/ReviewsListing.vue'
import SpamListing from './pages/spam/SpamListing.vue'
import MergeBusinessProfiles from './pages/profile-management/MergeBusinessProfiles.vue'
import ReviewsShareQRCodes from './pages/collect-reviews/QRCodes.vue'
import ReviewQRCodesWidget from './widgets/ReviewQRCodesWidget.vue'
import BusinessNotes from './pages/admin/BusinessNotes'
import {
  AdsBaseTemplate,
  AdsCreator,
  AdsLibrary,
  AverageRating,
  AverageReplyTime,
  BusinessReviewsListNew,
  CompetitorIndex,
  GoogleAnalytics,
  NPSAnalytics,
  NPSCompare,
  RatingsCompare,
  ReplyCompare,
  ReviewAnalytics,
  ReviewDetailedStats,
  ReviewInviteHistory,
  ReviewsCompare,
  TrustIndexCompare,
  Mip
} from '@/pages'
import ReviewInvites from './pages/analytics/invites/ReviewInvites'
import InviteTab from '@/pages/analytics/invites/InviteTab'
import ConversionRateTab from '@/pages/analytics/invites/ConversionRateTab'
import TrustIndexIndustryRankingPage
  from '@/pages/analytics/trust-index-and-industry-ranking/TrustIndexIndustryRankingPage'
import AnalyticsTrustIndex from '@/pages/analytics/trust-index-and-industry-ranking/AnalyticsTrustIndex'
import NewOnboard from '@/pages/onboarding/Onboard'
import FreeOnboard from '@/pages/onboarding/FreeOnboard'
import CheckoutOnboard from '@/pages/onboarding/Checkout'
import BillingCheckout from '@/pages/billing/new/BillingCheckout'
// import AnalyticsIndustryRanking from '@/pages/analytics/trust-index-and-industry-ranking/AnalyticsIndustryRanking'
import EmailSettingLayout from '@/pages/collect-reviews/email-settings/EmailSettingLayout'
import LookAndFeel from '@/pages/collect-reviews/email-settings/LookAndFeel'
import GeneralSettings from '@/pages/collect-reviews/email-settings/GeneralSettings'
import EmailAndSMSInviteLayout from '@/pages/collect-reviews/email-and-sms-invites/EmailAndSMSInviteLayout'
import EmailAndSMS from '@/pages/collect-reviews/email-and-sms-invites/EmailAndSMS'

const routes = [
  {
    path: '/mip',
    name: 'Mip',
    component: Mip
  },
  {
    path: '/features',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'Features',
        component: Features
      }
    ]
  },
  {
    path: '/docs/api/v5',
    name: 'Documentation',
    component: () => import('@/pages/documentation/MasterLayout'),
    children: [
      {
        path: ':name?',
        name: 'API Document Main Content',
        component: () => import('@/pages/documentation/MainContent')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: ForgotPassword
  },
  {
    path: '/update-password/:id',
    name: 'Update Password',
    component: UpdatePassword,
    props: true
  },
  {
    path: '/invites/new/:id',
    name: 'Accept Invite',
    component: AcceptInvite,
    props: true
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '/home/',
    component: PublicLayout,
    children: [
      {
        path: '',
        name: 'Home Page',
        component: HomePage
      }
    ]
  },
  {
    path: '/',
    meta: { requiresAuth: true, requiresPaid: true },
    component: MasterLayout,
    children: [
      {
        path: '',
        name: 'HomeNew',
        component: HomeNew
      },
      {
        path: 'collect-reviews',
        name: 'Collect Reviews',
        component: CollectReviewsMobile
      },
      {
        path: 'review-dashboard',
        name: 'Review Dashboard',
        component: ReviewDashboard
      },
      {
        path: 'users',
        name: 'Users',
        component: Users
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: '/edit-user/:id',
        name: 'EditUser',
        component: EditUser,
        props: true
      },
      {
        path: '/invites/invite-user',
        name: 'InviteUser',
        component: InviteUser
      },
      {
        path: '/reviews',
        name: 'ListReviews',
        component: BusinessReviewsListNew
      },
      {
        path: '/review/:permalink',
        name: 'ViewReview',
        component: BusinessReviewsListNew
      },
      {
        path: '/report-review/:permalink',
        name: 'ReportReview',
        component: ReportReview,
        props: true
      },
      {
        path: '/onboard-verification',
        name: 'BusinessOnboardVerification',
        meta: { isAdminUri: true },
        component: BusinessOnboardVerification
      },
      {
        path: '/businesses',
        name: 'Businesses',
        meta: { isAdminUri: true },
        component: Businesses
      },
      /* {
        path: '/fb-integration',
        name: 'FbIntegration',
        component: FbIntegration,
        props: true
      }, */
      {
        path: '/ads',
        meta: { requiresAuth: true },
        component: AdsBaseTemplate,
        children: [
          {
            path: 'creator',
            name: 'AdsCreator',
            component: AdsCreator
          },
          {
            path: 'library',
            name: 'AdsLibrary',
            component: AdsLibrary
          }
        ]
      },
      {
        path: '/collect-reviews',
        name: 'EmailSettingLayout',
        component: EmailSettingLayout,
        children: [
          {
            path: 'look-and-feel',
            name: 'LookAndFeel',
            component: LookAndFeel
          },
          {
            path: 'general-settings',
            name: 'GeneralSettings',
            component: GeneralSettings
          }
        ]
      },
      {
        path: '/collect-reviews',
        name: 'EmailAndSMSInviteLayout',
        component: EmailAndSMSInviteLayout,
        children: [
          {
            path: 'email-and-sms',
            name: 'EmailAndSMS',
            component: EmailAndSMS
          }
        ]
      },
      {
        path: '/integrations/api',
        name: 'API Integration',
        component: () => import('@/pages/integrations/API')
      },
      {
        path: '/collect-reviews/google-reviews',
        name: 'ReviewInviteGoogleReviews',
        component: ReviewInviteGoogleReviews
      },
      {
        path: '/collect-reviews/review-invites',
        name: 'ReviewInvitesLayout',
        component: ReviewInvitesLayout,
        children: [
          {
            path: 'google-reviews',
            name: 'ReviewInviteGoogleReviews2',
            component: ReviewInviteGoogleReviews
          },
          {
            path: 'template',
            name: 'ReviewInviteTemplate',
            component: ReviewInviteTemplate
          },
          {
            path: 'send',
            name: 'ReviewInviteSends',
            component: ReviewInviteSends
          },
          {
            path: 'SMSSetup',
            name: 'ReviewInviteSMSSetup',
            component: ReviewInviteSMSSetup
          }
        ]
      },
      {
        path: '/collect-reviews/review-invites/history',
        name: 'ReviewInviteHistory',
        component: ReviewInviteHistory
      },
      {
        path: '/collect-reviews/review-share-qrcode',
        name: 'ReviewsShareQRCodes',
        component: ReviewsShareQRCodes
      },
      {
        path: '/collect-reviews/review-share',
        name: 'ReviewsShare',
        component: ReviewsShare
      },
      {
        path: '/onsite-widgets/',
        name: 'OnsiteWidgetsLayout',
        component: Badges
      },
      {
        path: '/onsite-widgets/details/:type',
        name: 'WidgetDetails',
        component: WidgetDetails
      },
      {
        path: '/business/profile',
        name: 'BusinessProfile',
        component: BusinessProfile
      },
      {
        path: '/billing',
        name: 'BillingIndexView',
        component: BillingIndex
      },
      {
        path: '/billing/edit-plan/:currentTier/:cycle',
        name: 'BillingPlanEdit',
        component: BillingEditPlan,
        props: true
      },
      {
        path: '/billing/checkout/:invoiceId',
        name: 'BillingInvoiceCheckout',
        component: BillingCheckout,
        props: true
      },
      {
        path: '/billing-history',
        name: 'BillingHistory',
        component: BillingHistory,
        props: true
      },
      {
        path: '/eft-manual-matching',
        name: 'EFTManualMatching',
        meta: { isAdminUri: true },
        component: EFTManualMatching
      },
      {
        path: '/invoices',
        name: 'Invoices',
        meta: { isAdminUri: true },
        component: Invoices
      },
      {
        path: '/billing-details',
        name: 'BillingDetails',
        component: BillingDetails
      },
      {
        path: '/reported-review',
        name: 'Reported Reviews',
        meta: { isAdminUri: true },
        component: ReportedReviewsListing
      },
      {
        path: '/reported-review/:businessSlug/:reportedReviewSlug/:reportSlug/:reportId/:reviewId',
        name: 'Reported Review Details',
        component: ReportedReviewDetails
      },
      {
        path: '/sweep',
        name: 'Sweep',
        meta: { isAdminUri: true },
        component: SweepReviewsListing
      },
      {
        path: '/profile-management',
        name: 'ProfileManagement',
        meta: { isAdminUri: true },
        component: MergeBusinessProfiles
      },
      {
        path: '/spam',
        name: 'spam',
        meta: { isAdminUri: true },
        component: SpamListing
      },
      {
        path: '/reviews-listing',
        name: 'ReviewsListing',
        meta: { isAdminUri: true },
        component: ReviewsListing
      },
      {
        path: '',
        name: 'UsersLayout',
        component: UsersLayout,
        children: [
          {
            path: '/users-list',
            name: 'reviewers',
            meta: { isAdminUri: true },
            props: true,
            components: {
              reviewers: ReviewersListing
            }
          },
          {
            path: '/users-list/reviewers',
            name: 'reviewersListing',
            meta: { isAdminUri: true },
            props: true,
            components: {
              reviewers: ReviewersListing
            }
          },
          {
            path: '/users-list/business-users',
            name: 'businessUsers',
            meta: { isAdminUri: true },
            props: true,
            components: {
              businessUsers: BusinessUsersListing
            }
          }
        ]
      },
      {
        path: '/reviewer-detail/:reviewerId',
        name: 'reviewer',
        meta: { isAdminUri: true },
        component: ReviewerDetails
      },
      {
        path: '/bizuser-detail/:bizUserId',
        name: 'bizUserDetails',
        meta: { isAdminUri: true },
        component: BizUserDetails
      }
    ]
  },
  {
    path: '/analytics',
    meta: { requiresAuth: true, requiresPaid: true },
    component: MasterLayout,
    children: [
      {
        path: 'reviews',
        name: 'Reviews Analytics',
        component: ReviewAnalytics,
        children: [
          {
            path: 'detailed-stats',
            name: 'ReviewDetailedStats',
            component: ReviewDetailedStats
          },
          {
            path: 'average-rating',
            name: 'AverageRating',
            component: AverageRating
          },
          {
            path: 'average-reply-time',
            name: 'AverageReplyTime',
            component: AverageReplyTime
          }
        ]
      },
      {
        path: 'invites',
        component: ReviewInvites,
        children: [
          {
            path: '',
            default: true,
            name: 'Invites',
            component: InviteTab
          },
          {
            path: 'conversions',
            name: 'Conversions',
            component: ConversionRateTab
          }
        ]
      },
      {
        path: 'nps',
        name: 'NPS',
        component: NPSAnalytics
      },
      {
        path: 'google',
        name: 'Google Analytics',
        component: GoogleAnalytics
      },
      {
        path: 'competitors',
        name: 'Competitor Reporting',
        component: CompetitorIndex,
        children: [
          {
            path: 'trust-index',
            name: 'TrustIndexCompare',
            component: TrustIndexCompare
          },
          {
            path: 'nps',
            name: 'NPSCompare',
            component: NPSCompare
          },
          {
            path: 'reviews',
            name: 'ReviewsCompare',
            component: ReviewsCompare
          },
          {
            path: 'ratings',
            name: 'RatingsCompare',
            component: RatingsCompare
          },
          {
            path: 'reply',
            name: 'ReplyCompare',
            component: ReplyCompare
          }
        ]
      },
      {
        path: 'trust-index-and-industry',
        name: 'AnalyticsLayoutTabLayout',
        component: TrustIndexIndustryRankingPage,
        children: [
          {
            default: true,
            path: 'trust-index',
            name: 'AnalyticsTrustIndex',
            component: AnalyticsTrustIndex
          }
          // ,
          // {
          //   path: 'industry-ranking',
          //   name: 'AnalyticsIndustryRanking',
          //   component: AnalyticsIndustryRanking
          // }
        ]
      }
    ]
  },
  {
    path: '',
    meta: { requiresAuth: true },
    component: MasterLayout,
    children: [
      {
        path: '/business/:businessSlugFromProp/review/:reviewPermalink/:reviewId',
        name: 'Business Review Details',
        props: true,
        meta: { isAdminUri: true },
        component: BusinessReviewDetails
      },
      {
        path: '',
        name: 'BusinessLayout',
        component: BusinessLayout,
        children: [
          {
            path: '/business/:slug/users',
            name: 'users',
            props: true,
            meta: { isAdminUri: true },
            components: {
              users: BusinessUsers
            }
          },
          {
            path: '/business/:slug/billing',
            name: 'billing',
            props: true,
            meta: { isAdminUri: true },
            components: {
              billing: BusinessBilling
            }
          },
          {
            path: '/business/:slug/invoices',
            name: 'invoices',
            props: true,
            meta: { isAdminUri: true },
            components: {
              invoices: BusinessInvoices
            }
          },
          {
            path: '/business/:slug/reviews',
            name: 'reviews',
            props: true,
            meta: { isAdminUri: true },
            components: {
              reviews: BusinessReviews
            }
          },
          {
            path: '/business/:slug/details',
            name: 'details',
            props: true,
            meta: { isAdminUri: true },
            components: {
              details: BusinessDetails
            }
          },
          {
            path: '/business/:slug/aliases',
            name: 'aliases',
            props: true,
            meta: { isAdminUri: true },
            components: {
              aliases: BusinessAliases
            }
          },
          {
            path: '/business/:slug/notes',
            name: 'notes',
            props: true,
            meta: { isAdminUri: true },
            components: {
              aliases: BusinessNotes
            }
          }
        ]
      }
    ]
  },
  {
    path: '/renew-or-upgrade-subscription/',
    meta: { requiresAuth: true },
    component: MasterLayout,
    children: [
      {
        path: '',
        name: 'Renew Package Index',
        component: RenewPackage,
        props: true
      },
      {
        path: 'upgrade-promo/:userHash',
        name: 'Renew Package',
        component: RenewPackage,
        props: true
      },
      {
        path: ':paymentType/:invoiceReference',
        name: 'Renew Package Payment Details',
        component: RenewPackagePaymentDetails,
        props: true
      }
    ]
  },
  {
    path: '/purchase-reviews/',
    meta: { requiresAuth: true },
    component: MasterLayout,
    children: [
      {
        path: '',
        name: 'Purchase Additional Reviews Index',
        component: PurchaseAdditionalReviews
      },
      {
        path: ':paymentType/:invoiceReference',
        name: 'Purchase Additional Reviews Payment Details',
        component: PurchaseAdditionalReviewsPaymentDetails,
        props: true
      }
    ]
  },
  {
    path: '/nps/thank-you',
    name: 'Thank You for your feedback',
    component: NPSThankYou
  },
  {
    path: '/nps/:npsSelection/:reviewPermalink',
    name: 'NPS Review Feedback Selection',
    component: NPSReviewFromEmailRedirect,
    props: true
  },
  {
    path: '/widgets/',
    component: WidgetLayout,
    children: [
      {
        path: 'business-stats/:slug',
        name: 'Business Stats Widget',
        props: true,
        component: BusinessStatsWidget
      },
      {
        path: 'review-feed/:slug',
        name: 'Review Feed Widget',
        props: true,
        component: TopReviewsVertical
      },
      {
        path: 'review-carousel/:slug',
        name: 'Review Carousel Widget',
        props: true,
        component: TopReviewsCarousel
      },
      {
        path: 'trust-index/:slug',
        name: 'TrustIndex Widget',
        props: true,
        component: TrustIndexFrameWidget
      },
      {
        path: 'trust-index/:slug/:filled',
        name: 'TrustIndex Widget Filled',
        props: true,
        component: TrustIndexFrameWidget
      },
      {
        path: 'review-qrcodes/:slug',
        name: 'Review QRCodes',
        props: true,
        component: ReviewQRCodesWidget
      },
      {
        path: 'star-rating/:slug',
        name: 'Star Rating Widget Frame',
        props: true,
        component: StarRatingWidgetFrame
      }
    ]
  },
  {
    path: '/onboard/',
    component: PublicLayout,
    children: [
      {
        path: 'create/:tier',
        name: 'Create New Account',
        // component: NewOnboard,
        beforeEnter: (to, from, next) => {
          let components = {
            default: [FreeOnboard, NewOnboard][to.params.tier === 'free' ? 0 : 1]
          }
          to.matched[1].components = components
          next()
        },
        props: true
      },
      {
        path: 'create/:tier/:frequency',
        name: 'Create New Paid Account',
        // component: NewOnboard,
        beforeEnter: (to, from, next) => {
          let components = {
            default: [FreeOnboard, NewOnboard][to.params.tier === 'free' ? 0 : 1]
          }
          to.matched[1].components = components
          next()
        },
        props: true
      },
      {
        path: 'checkout/:business_id/:tier/:frequency/:invoice?',
        name: 'Checkout New Paid Account',
        component: CheckoutOnboard,
        props: true
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

Vue.use(VueMeta)

Vue.use(VueGtm, {
  id: 'GTM-56F63S7', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false // Whether or not display console logs debugs (optional)
})

router.beforeEach((to, from, next) => {
  if (process.env.MAINTENANCE_MODE === 'true') {
    if (to.name === 'Mip') {
      next()
    } else {
      next({
        name: 'Mip'
      })
    }
  } else {
    window.scrollTo(0, 0)
    window.pageTracked = false
    next()

    if (to.name === 'BillingPlanEdit' && to.params.currentTier === 'free') {
      next({
        name: 'BillingPlanEdit',
        params: { currentTier: 'g1', cycle: 'monthly' }
      })
    } else {
      next()
    }

    /**
     * We are redirecting /, /home, /features and /packages to hubspot i.e biz.hellopeter.com and their CMS will render those pages
     */
    const prodPaths = ['/', '/home', '/packages', '/features']
    const bizPortal = 'https://biz.hellopeter.com'
    if (to.matched.some(record => record.meta.requiresAuth)) {
      const isLoggedIn = !!localStorage.auth_token
      const expiredToken = (token) => {
        let decodedToken = jwtDecode(token)
        let now = Date.now() / 1000
        return decodedToken.exp < Number(now.toFixed(0))
      }
      /** Check user can access page and switch menu bar accordingly**/
      localStorage.setItem('is_admin_menu_active', false)
      if (to.meta.isAdminUri) {
        localStorage.setItem('is_admin_menu_active', true)
      }
      if (!isLoggedIn || expiredToken(localStorage.auth_token)) {
        const isAdminMenuActive = JSON.parse(localStorage.getItem('is_admin_menu_active')) ? JSON.parse(localStorage.getItem('is_admin_menu_active')) : false
        if (localStorage.getItem('auth_token') !== null && expiredToken(localStorage.auth_token)) {
          localStorage.clear()
          if (typeof window.Intercom !== 'undefined') {
            window.Intercom('shutdown')
          }
        }
        if (process.env.NODE_ENV === 'production' && prodPaths.includes(to.path)) {
          window.location = bizPortal + to.path
        } else {
          if (to.path === '/') { // redirect to home page if not logged in and route is /
            next({
              path: '/home'
            })
          } else {
            next({
              path: '/login',
              query: {
                redirect: to.fullPath,
                isadminactive: isAdminMenuActive
              }
            })
          }
        }
      } else {
        const userInfo = JSON.parse(localStorage.getItem('billingDetails'))
        const isFreePlan = typeof userInfo !== 'undefined' && userInfo.subscription !== 'undefined' && userInfo.subscription.name === 'Free'
        const allowedRoutes = ['BillingIndexView', 'BillingPlanEdit', 'BillingInvoiceCheckout', 'BillingHistory']
        if (to.matched.some(record => record.meta.requiresPaid) && isFreePlan && !allowedRoutes.includes(to.name)) {
          next({
            path: '/billing/edit-plan/g1/monthly'
          })
        } else {
          next()
        }
      }
    } else {
      if (process.env.NODE_ENV === 'production' && prodPaths.includes(to.path)) {
        window.location = bizPortal + to.path
      } else {
        next()
      }
    }
    if (!to.query.flash) {
      closeFlash()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js